import { type Payouts } from '@airwallex/components-sdk'

import { type CreateAirwallexPaymentMethodPayload } from '@webapp/platform/banking'

export class FormatAirwallexBeneficiaryForSubmissionUseCase {
  execute = (
    vendorId: number,
    beneficiaryData: Payouts.BeneficiaryFormSubmitResponse
  ): CreateAirwallexPaymentMethodPayload => {
    const beneficiaryFormData = beneficiaryData.values

    return {
      vendor_id: vendorId,
      data: beneficiaryFormData,
    }
  }
}
